module.exports = __webpack_public_path__ + "static/Icons_USDA_active-a1fe67419783115d5f319301cd72218a.png";